/// <reference types="vite/client" />

export const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'https://dev.api.vizit.com';
export const PENDO_API_KEY = import.meta.env.VITE_PENDO_API_KEY;
export const HELP_SCOUT_BEACON_ID = import.meta.env.VITE_HELP_SCOUT_BEACON_ID;

export const VIZIT_ENV = import.meta.env.VITE_VIZIT_ENV ?? 'dev';
